export const STATUS_COPY = {
    Received: { label: 'Received', modifier: 'received' },
    InProgress: { label: 'In progress', modifier: 'in-progress' },
    Complete: { label: 'Complete', modifier: 'complete' },
};

const UNKNOWN_STATUS = { label: 'Unknown', modifier: 'unknown' };

export const getStatusCopy = (status) => STATUS_COPY[status] || UNKNOWN_STATUS;

export const RAISED_BY_COPY = {
    Customer: 'Raised by you',
    Internal: 'Raised internally',
};

export const getRaisedByLabel = (raisedBy) => RAISED_BY_COPY[raisedBy] || '-';

export const NOT_APPLICABLE = 'Not Applicable';

export const getColumnValue = (value) => {
    if (typeof value !== 'string') return NOT_APPLICABLE;
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : NOT_APPLICABLE;
};

export const SORT_OPTIONS = [
    { value: 'newest', label: 'Newest first' },
    { value: 'oldest', label: 'Oldest first' },
];

const DATE_VALUE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

const isValidDateValue = (value) => {
    if (typeof value !== 'string' || !DATE_VALUE_PATTERN.test(value)) return false;
    const parsed = new Date(`${value}T00:00:00Z`);
    if (Number.isNaN(parsed.getTime())) return false;
    return parsed.toISOString().slice(0, 10) === value;
};

export const normaliseDateRange = (from, to) => {
    const validFrom = isValidDateValue(from) ? from : null;
    const validTo = isValidDateValue(to) ? to : null;
    if (validFrom && validTo && validFrom > validTo) {
        return { from: validTo, to: validFrom };
    }
    return { from: validFrom, to: validTo };
};

export const getExpectedByDate = (createdOn, slaSeconds) => {
    if (!createdOn) return null;
    const created = new Date(createdOn);
    const seconds = Number(slaSeconds);
    if (Number.isNaN(created.getTime()) || slaSeconds == null || !Number.isFinite(seconds) || seconds <= 0) return null;
    return new Date(created.getTime() + seconds * 1000);
};
